export default __webpack_public_path__ + "static/media/coversmEN.8bf282e7.jpg";